import { useEffect, useState } from 'react';

import { SettingOutlined } from '@ant-design/icons';
import { Modal as ModalAntD, PageHeader, Result, Skeleton } from 'antd';
import { useHistory, useLocation } from 'react-router';
import { T } from 'react-translator-component';

import * as S from './styled';

import {
  getVirtualGroup,
  updateVirtualGroup,
} from '../../../../hooks/virtualgroup';
import { COLORS } from '../../../molecules/ConnectorColored/helpers';
import VirtualGroupEditForm from '../../../organisms/VirtualGroupForm/VirtualGroupEditForm';

const Modal: any = ModalAntD;

const VirtualGroupEditPage = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const { pathname }: any = useLocation();
  const [, setUpdateLoading] = useState(false);

  const [virtualGroup, setVirtualGroup] = useState<any>();
  const [id] = useState(pathname.split('/').pop());

  const handleUpdateVirtualGroup = async (values: any) => {
    setUpdateLoading(true);

    try {
      await updateVirtualGroup(id, {
        ...virtualGroup,
        name: values.name,
        description: values.description,
      });

      setSuccess(true);
    } catch {
      setTimeout(() => setError(true), 1500);
    } finally {
      setTimeout(() => setUpdateLoading(false), 1500);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const { data } = await getVirtualGroup(id);

        setVirtualGroup(data);
      } finally {
        setTimeout(() => setLoading(false), 2000);
      }
    })();
  }, [pathname, id]);

  return (
    <>
      <S.Wrapper>
        <PageHeader
          onBack={() => history.push(`/virtual-groups/view/${id}`)}
          title={
            <>
              <SettingOutlined
                style={{ position: 'relative', marginRight: 16 }}
                color={COLORS.black}
                height={20}
                width={20}
              />

              {T('Edit Configuration')}
            </>
          }
        />

        <S.Blank>
          <Skeleton
            loading={loading}
            active
            paragraph={{
              rows: 5,
              width: '100%',
            }}
            title={false}
          >
            <VirtualGroupEditForm
              initialValues={{
                ...virtualGroup,
              }}
              loading={loading}
              onSubmit={handleUpdateVirtualGroup}
            />
          </Skeleton>
        </S.Blank>
      </S.Wrapper>

      <Modal
        visible={success}
        onOk={() => {}}
        onCancel={() => {}}
        closable={false}
        footer={null}
      >
        <Result
          status='success'
          title='Configuração atualizada com sucesso!'
          extra={[
            <S.Button
              type='primary'
              key='console'
              size='large'
              onClick={() => {
                history.push(`/virtual-groups/view/${id}`);
              }}
            >
              Ver listagem atualizada
            </S.Button>,
          ]}
        />
      </Modal>
      <Modal visible={error} closable={false} footer={null}>
        <Result
          status='error'
          title='Não foi possível atualizar a configuração!'
          extra={[
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={() => setError(false)}
            >
              Voltar para a visualização do grupo
            </S.Button>,
          ]}
        />
      </Modal>
    </>
  );
};

export default VirtualGroupEditPage;
